/**
 * @fileoverview Agent definition for critique-prose-flow.
 *
 * This agent analyzes prose for rhythm, pacing, sentence variety,
 * transitions, and exposition integration.
 *
 * @category narrative.prose.critique
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

// =============================================================================
// AGENT DEFINITION
// =============================================================================

export const definition: AppAgentDefinition = {
  id: 'critique-prose-flow',
  kind: 'primitive',
  name: 'Prose Flow Critic',
  description: 'Analyzes prose for rhythm, pacing, sentence variety, transitions, and exposition integration.',
  category: 'writing',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,

  // --- Metadata (Hybrid Architecture) ---
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2024-08',
    lastUpdated: '2026-01',
    taxonomyPath: 'narrative.prose.critique',
    usedBy: [
      'use-critique-prose-flow.ts',
    ],
    usedInComposites: [
      'critique-committee-v2',
    ],
    relatedAgents: [
      'critique-sensory-atmosphere',
      'critique-voice-emotion',
    ],
  },
};
